var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSunDim = function SvgIconSunDim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 .875a1 1 0 0 1 1 1v.75a1 1 0 1 1-2 0v-.75a1 1 0 0 1 1-1m0 6.5a4.625 4.625 0 1 0 0 9.25 4.625 4.625 0 0 0 0-9.25M5.375 12a6.625 6.625 0 1 1 13.25 0 6.625 6.625 0 0 1-13.25 0m14.494-6.455a1 1 0 0 0-1.414-1.415l-.534.535a1 1 0 0 0 1.414 1.414zM20.375 12a1 1 0 0 1 1-1h.75a1 1 0 1 1 0 2h-.75a1 1 0 0 1-1-1m-1.04 5.921a1 1 0 1 0-1.414 1.414l.534.535a1 1 0 0 0 1.414-1.415zM12 20.375a1 1 0 0 1 1 1v.75a1 1 0 1 1-2 0v-.75a1 1 0 0 1 1-1m-5.92-1.04a1 1 0 1 0-1.415-1.414l-.534.534a1 1 0 0 0 1.414 1.415zM.874 12a1 1 0 0 1 1-1h.75a1 1 0 1 1 0 2h-.75a1 1 0 0 1-1-1m4.67-7.87a1 1 0 1 0-1.414 1.415l.534.534A1 1 0 1 0 6.08 4.665z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSunDim;